module.exports = __webpack_public_path__ + "static/media/light_yellow-theme.fd2b7891.png";